import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface DebugLog {
  id: string
  timestamp: Date
  level: 'log' | 'info' | 'warn' | 'error'
  message: string
  data?: any
  source?: string
}

interface DebugState {
  isEnabled: boolean
  logs: DebugLog[]
  maxLogs: number
}

const initialState: DebugState = {
  isEnabled: localStorage.getItem('debug_panel_enabled') === 'true',
  logs: [],
  maxLogs: 500
}

const debugSlice = createSlice({
  name: 'debug',
  initialState,
  reducers: {
    toggleDebugPanel: (state) => {
      state.isEnabled = !state.isEnabled
      localStorage.setItem('debug_panel_enabled', state.isEnabled.toString())
    },
    addDebugLog: (state, action: PayloadAction<Omit<DebugLog, 'id' | 'timestamp'>>) => {
      const log: DebugLog = {
        ...action.payload,
        id: `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
        timestamp: new Date()
      }
      state.logs.unshift(log)
      
      // Keep only the latest maxLogs entries
      if (state.logs.length > state.maxLogs) {
        state.logs = state.logs.slice(0, state.maxLogs)
      }
    },
    setDebugLogs: (state, action: PayloadAction<DebugLog[]>) => {
      state.logs = action.payload
    },
    clearDebugLogs: (state) => {
      state.logs = []
    }
  }
})

export const { toggleDebugPanel, addDebugLog, setDebugLogs, clearDebugLogs } = debugSlice.actions
export default debugSlice.reducer